import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import Header from "../components/Header";
import Footer from "../components/Footer";
import PDF from "../assets/files/ki.pdf";
import Image1 from "../assets/images/pdf/1.png";
import Image2 from "../assets/images/pdf/2.png";
import Image3 from "../assets/images/pdf/3.png";
import Image4 from "../assets/images/pdf/4.png";
import Image5 from "../assets/images/pdf/5.png";
import Image6 from "../assets/images/pdf/6.png";
import Image7 from "../assets/images/pdf/7.png";
import Image8 from "../assets/images/pdf/8.png";
import Image9 from "../assets/images/pdf/9.png";
import Image10 from "../assets/images/pdf/10.png";
import Image11 from "../assets/images/pdf/11.png";
import Image12 from "../assets/images/pdf/12.png";
import Image13 from "../assets/images/pdf/13.png";
import Image14 from "../assets/images/pdf/14.png";
import Image15 from "../assets/images/pdf/15.png";
import Image16 from "../assets/images/pdf/16.png";
import Image17 from "../assets/images/pdf/17.png";
import Image18 from "../assets/images/pdf/18.png";
import Image19 from "../assets/images/pdf/19.png";
import Image20 from "../assets/images/pdf/20.png";
import Image21 from "../assets/images/pdf/21.png";
import Image22 from "../assets/images/pdf/22.png";
import Image23 from "../assets/images/pdf/23.png";
import Image24 from "../assets/images/pdf/24.png";
import Image25 from "../assets/images/pdf/25.png";
import Image26 from "../assets/images/pdf/26.png";
import Image27 from "../assets/images/pdf/27.png";
import Image28 from "../assets/images/pdf/28.png";
import Image29 from "../assets/images/pdf/29.png";
import Image30 from "../assets/images/pdf/30.png";
import Image31 from "../assets/images/pdf/31.png";
import Image32 from "../assets/images/pdf/32.png";
import Image33 from "../assets/images/pdf/33.png";

/* import { Document, Page } from "react-pdf"; */
import { Document, Page } from "react-pdf/dist/esm/entry.webpack";

const Container = styled.div`
  display: flex;
  min-height: calc(100vh);

  flex-direction: column;
  overflow: scroll;
  position: relative;
  @media screen and (max-width: 1024px) {
    width: 100%;
    margin: 0;
  }
`;
const Wrapper = styled.div`
  width: 1200px;
  margin: 96px auto;
  height: 100%;
  @media screen and (max-width: 1024px) {
    width: 100%;
  }

  & > div {
    padding: 20px 10rem 0;
    @media screen and (max-width: 320px) {
      padding: 0 1rem 0;
    }
    @media screen and (max-width: 425px) and (min-width: 321px) {
      padding: 0 3rem 0;
    }
    @media screen and (max-width: 768px) and (min-width: 426px) {
      padding: 0 5rem 0;
    }
  }
`;
const Text = styled.p`
  color: #1d4666;
  font-weight: 400;
  font-size: 20px;
`;
const PdfWrapperWeb = styled.div`
  height: 700px;
  overflow: scroll;
  border: 1px solid #1d4666;
  /*   margin-bottom: 150px; */
  margin-top: 30px;
  border-radius: 3px;
`;
const Image = styled.img`
  width: 50%;

  &.hidden {
    @media screen and (max-width: 768px) {
      display: none;
    }
  }
  &.mobile {
    @media screen and (max-width: 768px) and (min-width: 426px) {
      margin: 0 0 0 38px;
    }
    @media screen and (max-width: 425px) {
      margin: 0 0 0 19px;
    }
  }
  @media screen and (max-width: 768px) {
    width: 100%;
  }
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
`;
const scroll_2 = keyframes`
 0%   { transform: translateY(0); opacity: 1; }
  25%  { opacity: 1; }
  75%  { transform: translateY(.6em); opacity: 0; }
  100% { transform: translateY(0); opacity: 0; }
`;
const ScrollExample = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;
const ScrollIcon = styled.span`
  display: block;
  position: relative;
  height: 2.5em;
  width: 1.5em;
  border: 2px solid #1d4666;
  border-radius: 1em;
`;
const ScrollIconDot = styled.span`
  display: block;
  position: absolute;
  left: 50%;
  background: #1d4666;
  height: 0.5em;
  width: 0.5em;
  top: 0.6em;
  margin-left: -0.25em;
  border-radius: 50%;
  transform-origin: top center;
  backface-visibility: hidden;
  animation: ${scroll_2} 2s ease-out infinite;
`;

const options = {
  cMapUrl: "cmaps/",
  cMapPacked: true,
};

function About() {
  const [file, setFile] = useState(PDF);
  const [numPages, setNumPages] = useState(null);
  const [dimensions, setDimensions] = useState({
    height: window.innerHeight,
    width: window.innerWidth,
  });

  const [init, setInit] = useState(false);

  function handleResize() {
    if (window.innerWidth > 1024) {
      setDimensions({
        height: window.innerHeight,
        width: 900,
      });
    } else if (window.innerWidth <= 1024 && window.innerWidth > 768) {
      setDimensions({
        height: window.innerHeight,
        width: 700,
      });
    } else if (window.innerWidth <= 768 && window.innerWidth > 668) {
      setDimensions({
        height: window.innerHeight,
        width: 500,
      });
    } else if (window.innerWidth <= 668 && window.innerWidth > 544) {
      setDimensions({
        height: window.innerHeight,
        width: 400,
      });
    } else if (window.innerWidth <= 544) {
      setDimensions({
        height: window.innerHeight,
        width: 275,
      });
    }
  }
  useEffect(() => {
    window.addEventListener("resize", handleResize);
  }, []);
  useEffect(() => {
    if (!init) {
      setInit(true);
      handleResize();
    }
  }, []);
  const onDocumentLoadSuccess = ({ numPages: nextNumPages }) => {
    setNumPages(nextNumPages);
  };
  return (
    <>
      <Container>
        <Header />
        <Wrapper>
          <div>
            {/*  <div style={{ marginBottom: "50px" }}>
              <Text>
                Kanal İstanbul, konumu, işlevi ve etki alanıyla Türkiye'nin
                stratejik hamlesidir.
              </Text>
              <Text>
                İstanbul Boğazı’nın maruz kaldığı riski minimize edecek Kanal
                İstanbul, Türkiye'yi bölgesinin lojistik üssü haline getirirken
                Marmarayı'da Avrasya'nın merkezi yapacak.
              </Text>
              <Text>
                Kanal İstanbul, dünyanın en büyük projelerinden biri olmasının
                yanında Türkiye’nin de vizyon projesidir.
              </Text>
            </div> */}
            <ScrollExample>
              <ScrollIcon>
                <ScrollIconDot />
              </ScrollIcon>
            </ScrollExample>
            <Row>
              <img src={Image1} alt="" />
            </Row>
            <Row>
              <Image src={Image2} alt="" className="hidden" />
              <Image src={Image3} alt="" />
            </Row>
            <Row>
              <Image src={Image4} alt="" />
              <Image src={Image5} alt="" className="mobile" />
            </Row>
            <Row>
              <Image src={Image6} alt="" />
              <Image src={Image7} alt="" />
            </Row>
            <Row>
              <Image src={Image8} alt="" />
              <Image src={Image9} alt="" />
            </Row>
            <Row>
              <Image src={Image10} alt="" />
              <Image src={Image11} alt="" />
            </Row>
            <Row>
              <Image src={Image12} alt="" />
              <Image src={Image13} alt="" />
            </Row>
            <Row>
              <Image src={Image14} alt="" />
              <Image src={Image15} alt="" />
            </Row>
            <Row>
              <Image src={Image16} alt="" />
              <Image src={Image17} alt="" />
            </Row>
            <Row>
              <Image src={Image18} alt="" />
              <Image src={Image19} alt="" />
            </Row>
            <Row>
              <Image src={Image20} alt="" />
              <Image src={Image21} alt="" />
            </Row>
            <Row>
              <Image src={Image22} alt="" />
              <Image src={Image23} alt="" />
            </Row>
            <Row>
              <Image src={Image24} alt="" />
              <Image src={Image25} alt="" />
            </Row>
            <Row>
              <Image src={Image26} alt="" />
              <Image src={Image27} alt="" />
            </Row>
            <Row>
              <Image src={Image28} alt="" />
              <Image src={Image29} alt="" />
            </Row>
            <Row>
              <Image src={Image30} alt="" />
              <Image src={Image31} alt="" />
            </Row>
            <Row>
              <Image src={Image32} alt="" />
              <Image src={Image33} alt="" />
            </Row>

            {/*    <PdfWrapperWeb style={{ width: dimensions.width }}>
              <Document
                file={file}
                onLoadSuccess={onDocumentLoadSuccess}
                options={options}
              >
                {Array.from(new Array(numPages), (el, index) => (
                  <Page
                    key={`page_${index + 1}`}
                    pageNumber={index + 1}
                    width={dimensions.width}
                  />
                ))}
              </Document>
            </PdfWrapperWeb> */}
          </div>
        </Wrapper>
        <Footer />
      </Container>
    </>
  );
}
export default About;
